export const CART_STORAGE_KEY = 'sakara-cart-id'
export const VARIANT_PAGINATION_LIMIT = 100
export const SELLING_PLAN_PAGINATION_LIMIT = 10
export const USER_ACCESS_TOKEN = 'sakara-user-access-token'
export const USER_ACCESS_POPS_TOKEN = 'sakara-user-access-pops-token'
export const ENCODED_CUSTOMER_ID = 'sakara-encoded-customer-id'
